import React, {useState, useEffect} from 'react';
import "../styles/About.css";

const SkillWord = props =>{

    const[fadeProp, setFadeProp] = useState({
        fade :'fade-in'
    });

    const skillsList = [ 'C++', 'Python', 'Machine Learning','Deep Learning','Computer Vision','Data Analysis','Power BI','MySQL','MS Excel','Flask'];
    const[skillname, setSkillName] = useState(skillsList[0]);
    const [itemNo, setItemNo] = useState(1);

    useEffect(()=>{
        const timeout = setInterval(() => {
            if(fadeProp.fade === 'fade-in'){
                setFadeProp({
                    fade : 'fade-out'
                });
            }
            else{
                setFadeProp({
                    fade : 'fade-in'
                });

                //Updating skill that shows up on UI
                setSkillName(skillsList[itemNo]);
                if(itemNo=== skillsList.length-1){
                  setItemNo(0);
                }
                else{
                  setItemNo(itemNo+1);
                }  
            }

            
        },2000);
        return () => clearInterval(timeout)
    },[fadeProp,skillname, itemNo, skillsList])

    return (
      <div>
          <h1 className={fadeProp.fade}>{skillname}</h1>
      </div>
    );
}

export default SkillWord;